import MPendingRitualCard from './MPendingRitualCard.vue';

export { MPendingRitualCard };
export default MPendingRitualCard;
